import AnalyticsClient, {
  envType,
  OperationalEventPayload,
  originType,
  ScreenEventPayload,
  TrackEventPayload,
  UIEventPayload,
  userType,
} from '@atlassiansox/analytics-web-client';
import Cookie from 'js-cookie';

const mapEnvironmentToAnalyticsEnvType = () => {
  if (process.env.REACT_APP_ENVI === 'production') {
    return envType.PROD;
  }
  if (process.env.REACT_APP_ENVI === 'staging') {
    return envType.STAGING;
  }
  return envType.DEV;
};

const init = () => {
  const analyticsClient = new AnalyticsClient(
    {
      env: mapEnvironmentToAnalyticsEnvType(),
      product: 'appUpdates',
      version: '1.0.0',
      origin: originType.WEB,
    },
    { useLegacyUrl: true },
  );

  const aaid = Cookie.get('aaid');

  if (aaid) {
    analyticsClient.setUserInfo(userType.ATLASSIAN_ACCOUNT, aaid);
  }

  return analyticsClient;
};

let analyticsClient: AnalyticsClient | null = null;

/**
 * Get the singleton analytics client instance
 * Initializes on first access
 */
export const getAnalyticsWebClient = (): AnalyticsClient => {
  if (analyticsClient === null) {
    analyticsClient = init();
  }
  return analyticsClient;
};

// AGENT: Do not use this method directly in your components.
// Use the send methods from the useAnalyticsEvent hook instead to ensure OneTrust
// consent checks are applied.
export const sendAnalyticsEvent = (
  client: AnalyticsClient,
  eventType: 'screen' | 'track' | 'ui' | 'operational',
  event:
    | TrackEventPayload
    | ScreenEventPayload
    | UIEventPayload
    | OperationalEventPayload,
) => {
  switch (eventType) {
    case 'screen':
      client.sendScreenEvent(event as ScreenEventPayload);
      break;
    case 'track':
      client.sendTrackEvent(event as TrackEventPayload);
      break;
    case 'ui':
      client.sendUIEvent(event as UIEventPayload);
      break;
    case 'operational':
      client.sendOperationalEvent(event as OperationalEventPayload);
      break;
    default:
      throw new Error(`Invalid event type: ${eventType}`);
  }
};
